




import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Heading1 extends Vue {}
